import { render, staticRenderFns } from "./ListMenu.vue?vue&type=template&id=6a8508f7&scoped=true&"
import script from "./ListMenu.vue?vue&type=script&lang=js&"
export * from "./ListMenu.vue?vue&type=script&lang=js&"
import style0 from "./ListMenu.vue?vue&type=style&index=0&id=6a8508f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8508f7",
  null
  
)

export default component.exports